import { atomWithStorage } from 'jotai/utils';
import { rawStringStorage } from './storage';

export const tokenAtom = atomWithStorage('token', '', rawStringStorage, {
    getOnInit: true,
});
